<ng-container *ngIf="(VideoReviewService.reviewData$ | async) as reviewData">
	<div [ngClass]="styles.header">
		<div [ngClass]="styles.btnWrapper">
			<button *ngIf="mediaFeatures?.aiSettings.enableContentAnalysis" type="button" class="btn btn-transparent" [ngClass]="styles.menuBtn" (click)="onAlertsTabClick()">
				<div [ngClass]="[styles.btnText, isAlertsTabOpen ? styles.isTabOpen : '']">
					{{ 'ComplianceAlerts' | translate }}
					<div *ngIf="reviewData.complianceAlerts.length" [ngClass]="[styles.alertCountContainer]">
						{{ reviewData.complianceAlerts.length }}
					</div>
				</div>
			</button>
			<button type="button" class="btn btn-transparent" [ngClass]="styles.menuBtn" (click)="onCommentsTabClick()">
				<span [ngClass]="[styles.btnText, !isAlertsTabOpen ? styles.isTabOpen : '']">
					{{ 'Comments' | translate }}
					<div *ngIf="reviewData.manualComments.length" [ngClass]="styles.alertCountContainer">
						{{ reviewData.manualComments.length }}
					</div>
				</span>
			</button>
		</div>
	</div>
	<div [ngClass]="styles.content">
		<ng-container *ngIf="isAlertsTabOpen; else commentsTab">
			<vb-loading-overlay *ngIf="VideoReviewService.showComplianceTabProcessingOverlay" [loadingMessage]="'ProcessingWaitMsg' | translate">
			</vb-loading-overlay>
			<ng-container *ngIf="reviewData.complianceAlerts.length; else noComplianceAlerts">
				<video-review-alert-entry *ngFor="let complianceAlert of reviewData.complianceAlerts" #complianceAlerts [attr.id]="complianceAlert.id" [ngClass]="complianceAlert.isContainerHighlighted ? styles.highlightedBackground : ''" [isReadOnlyMode]="statusInfo?.isRejectedApprovalStage" [complianceAlert]="complianceAlert" [videoId]="video.id" [showHoursInTimestamp]="isShowHours" (timeClicked)="onTimeClicked($event)">
				</video-review-alert-entry>
			</ng-container>
			<ng-template #noComplianceAlerts>
				<div *ngIf="(VideoReviewService.noComplianceAlerts$ | async) && !VideoReviewService.showComplianceTabProcessingOverlay" [ngClass]="styles.alertsTabMsgWrapper">
					{{ 'ComplianceAlerts_NoAlertsFound' | translate }}
				</div>
				<div *ngIf="(VideoReviewService.contentAnalysisNotRan$ | async) && !VideoReviewService.showComplianceTabProcessingOverlay" [ngClass]="styles.alertsTabMsgWrapper">
					{{ 'ComplianceAlerts_NoAnalysisJob' | translate }}
				</div>
			</ng-template>
		</ng-container>
		<ng-template #commentsTab>
			<vb-loading-overlay *ngIf="VideoReviewService.showManualCommentsTabProcessingOverlay" [loadingMessage]="'ProcessingWaitMsg' | translate">
			</vb-loading-overlay>
			<video-review-manual-comment-input *ngIf="!statusInfo?.isRejectedApprovalStage" [ngClass]="styles.commentEntryInput" [showHoursInTimestamp]="isShowHours" [currentTime]="vgApi?.currentTime" [videoId]="video.id" [vgApi]="vgApi" [currentApprovalStepId]="video.approval.stepId">
			</video-review-manual-comment-input>
			<div [ngClass]="styles.commentEntriesWrapper" class="vb-scrollbar">
				<video-review-manual-comment-entry *ngFor="let manualComment of reviewData.manualComments" #manualComments [attr.id]="manualComment.id" [ngClass]="manualComment.isContainerHighlighted ? styles.highlightedBackground : ''" [isReadOnlyMode]="statusInfo?.isRejectedApprovalStage" [manualComment]="manualComment" [videoId]="video.id" [showHoursInTimestamp]="isShowHours" (timeClicked)="onTimeClicked($event)">
				</video-review-manual-comment-entry>
			</div>
		</ng-template>
	</div>
</ng-container>